import Divider from "components/Divider";
import H1 from "components/H1";
import H4 from "components/H4";
import Toast from "components/Toast";
import React, { useState, useEffect } from "react";
import userSvc from "services/userSvc";
import { logout } from "_redux/actions/authAction";
import { useDispatch } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import { isValidPassword, initialValidationPassword, isPassword } from "utils/regexExp";
import authSvc from "services/authSvc";
import ArrowIcon from "_assets/images/dynamic/ArrowIcon";
import Button from "components/Button";
import TextInputPassword from "components/TextInputPassword";
import Indicator from "_assets/images/dynamic/Indicator";
import TextInput from "components/TextInput";
import Wrapper from "./Wrapper";
// import { Alert } from "utils/Alert";

const ChangePasswordPage = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [toastData, setToastData] = useState({});
  const [toastVisible, setToastVisible] = useState(false);
  const [tooltipValidation, setTooltipValidation] = useState({
    visible: false,
    value: initialValidationPassword(),
  });
  const [validation, setValidation] = useState();
  const initialValidation = {
    isOldPassword: { isValid: true, msg: "" },
    password: { isValid: true, msg: "" },
    confirmPassword: { isValid: true, msg: "" },
    currentPassword: { isValid: true, msg: "" },
  };
  const [validIndicator, setValidIndicator] = useState(initialValidation);
  // const [existPasswordNotMatch, setExistPasswordNotMatch] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    // update tooltip validation
    if (password) {
      const validationPassword = isValidPassword(password);
      const foundFalse = validationPassword.find((item) => !item.isValid);
      setTooltipValidation({ visible: !!foundFalse, value: validationPassword });
    } else {
      setTooltipValidation({ visible: false, value: initialValidationPassword() });
    }
  }, [password]);

  useEffect(() => {
    if (password) {
      const validationPassword = isValidPassword(password);
      setValidIndicator(validationPassword);
    }
  }, [password]);

  const handleForgotPassword = async () => {
    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    setLoading(true);
    try {
      const data = {
        oldPassword: currentPassword,
        password,
        confirmPassword,
      };
      const currentUser = authSvc.currentUser();
      await userSvc.changePassword(currentUser.user.id, data);
      setLoading(false);
      const getToastData = {
        description: "Your password has been successfully changed",
      };
      setToastData(getToastData);
      setToastVisible(true);
      localStorage.removeItem("DATA_FORM");
      setTimeout(() => {
        dispatch(logout());
        history.replace("/auth/login");
      }, 2000);
    } catch (err) {
      setLoading(false);
      // const errMessage = err.response?.data?.data[0]?.msg || err.message;
      // if(errMessage === 'Password not match'){
      //   setExistPasswordNotMatch(true);
      // }else{
      //   setExistPasswordNotMatch(false);
      //   Alert.showStatus(
      //     'error',
      //     'Something wrong',
      //     errMessage
      //   )
      // }
    }
  };

  const validateForm = () => {
    let validationForm = initialValidation;
    // const { password, } = password;
    // const { confirmPassword } = confirmPassword;
    // required rules

    if (!currentPassword) {
      validationForm = {
        ...validationForm,
        currentPassword: { ...validationForm.currentPassword, isValid: false, msg: "Current Password is required" },
      };
    }
    if (!password) {
      validationForm = {
        ...validationForm,
        password: { ...validationForm.password, isValid: false, msg: "Password is required" },
      };
    }
    if (!confirmPassword) {
      validationForm = {
        ...validationForm,
        confirmPassword: {
          ...validationForm.confirmPassword,
          isValid: false,
          msg: "Password Confirmation is required",
        },
      };
    }

    if (password && confirmPassword && password !== confirmPassword) {
      validationForm = {
        ...validationForm,
        password: {
          ...validationForm.password,
          isValid: false,
          msg: "Password not match with Password Confirmation",
        },
        confirmPassword: {
          ...validationForm.confirmPassword,
          isValid: false,
          msg: "Password Confirmation not match with Password",
        },
      };
    }

    if (password && !isPassword(password)) {
      validationForm = {
        ...validationForm,
        password: { ...validationForm.password, isValid: false, msg: "Password not valid" },
      };
    }

    setValidation(validationForm);
    let result = true;
    Object.entries(validationForm).forEach(([key, { isValid }]) => {
      if (!isValid) result = false;
      console.log(key);
    });

    if (tooltipValidation.visible) {
      result = false;
    }

    return result;
  };

  return (
    <Wrapper className="d-flex flex-column">
      <Link to="/profile/edit-profile" className="fsize-14 fweight-500 cl-grey-deep text-decoration-none d-flex align-items-center mb-3">
        <ArrowIcon color="#E81255" />
        <span className="fsize-14 fweight-600 ms-2 mb-0 cl-primary">
          Back
        </span>
      </Link>
      <H1 className="margin-bottom-15 fsize-24 mb-2">Change Password</H1>
      <H4>
        Change password regularly to ensure account security.
      </H4>
      <Divider style={{ marginBlock: 30 }} />
      <TextInput
        title="Current password"
        value={currentPassword}
        inputType="password"
        placeholder="Enter your current password"
        className="margin-bottom-20"
        onChange={(event) => setCurrentPassword(event.target.value)}
        // invalidFeedback={error.password}
        tooltipValidation={tooltipValidation}
        invalidFeedback={validation?.currentPassword?.msg}
      />
      <TextInput
        title="New password"
        value={password}
        invalidFeedback={validation?.password?.msg}
        onChange={(event) => setPassword(event.target.value)}
      />
      <TextInputPassword
        className="margin-bottom-10"
        inputClassname="py-2"
        source="password"
        id="confirm_password"
        title="Repeat New Password"
        placeholder="Enter new password"
        value={confirmPassword}
        invalidFeedback={validation?.confirmPassword?.msg}
        onChange={(event) => setConfirmPassword(event.target.value)}
      />

      <div className="wrapper_indicator mt-1 mb-3">
        <p className={`${validIndicator[4]?.isValid ? 'cl-neutral600' : 'cl-neutral100'} mb-0 fsize-12`}>Your password must include:</p>
        <div className="fsize-12 fweight-400 line-height-24">
          <p className={`${validIndicator[1]?.isValid && validIndicator[2]?.isValid ? 'cl-neutral600' : 'cl-neutral100'} mb-0`}>
            <Indicator className="me-2" color={validIndicator[1]?.isValid && validIndicator[2]?.isValid ? "#35B86D" : "#B3BAC5"} />
            Uppercase and lowercase letter.
          </p>
          <p className={`${validIndicator[3]?.isValid && validIndicator[4]?.isValid ? 'cl-neutral600' : 'cl-neutral100'} mb-0`}>
            <Indicator className="me-2" color={validIndicator[3]?.isValid && validIndicator[4]?.isValid ? "#35B86D" : "#B3BAC5"} />
            One number and symbol.
          </p>
          <p className={`${validIndicator[0]?.isValid ? 'cl-neutral600' : 'cl-neutral100'} mb-0`}>
            <Indicator className="me-2" color={validIndicator[0]?.isValid ? "#35B86D" : "#B3BAC5"} />
            8 characters long.
          </p>
        </div>
      </div>
      <div>
        <Button disabled={!password || !confirmPassword} loading={loading} handleRoute={() => handleForgotPassword()} primary>
          Save New Password
        </Button>
      </div>
      <Toast
        setIsVisible={(val) => setToastVisible(val)}
        isVisible={toastVisible}
        description={toastData.description}
        undo={toastData.undo}
      />
    </Wrapper>
  );
};

export default ChangePasswordPage;
